"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.modalSizes = void 0;
const sizes = {
  xxSmall: 4,
  xSmall: 8,
  small: 12,
  medium: 16,
  large: 24,
  xLarge: 32,
  xxLarge: 48
};
exports.sizes = sizes;
const modalSizes = {
  small: 320,
  medium: 480,
  large: 640,
  xLarge: 720
};
exports.modalSizes = modalSizes;
//# sourceMappingURL=spacing.js.map